import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import axios from "axios";
import MDBox from "admin/components/MDBox";
import MDTypography from "admin/components/MDTypography";
import MDInput from "admin/components/MDInput";
import DashboardLayout from "admin/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "admin/examples/Navbars/DashboardNavbar";

const API = process.env.REACT_APP_APIHOST || "http://localhost:3033";
const COUNTRIES = ["all","Syria","Lebanon","Palestine","Jordan","Iraq","Yemen","Egypt","Saudi Arabia","UAE","Kuwait","Bahrain","Qatar","Oman","Turkey","Iran","Afghanistan","Pakistan","Libya","Tunisia","Algeria","Morocco","Sudan","Somalia","Israel"];
const TYPES = ['wire','local','government','osint','defense'];

function DataSources() {
    const [sources, setSources] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showAdd, setShowAdd] = useState(false);
    const [form, setForm] = useState({ name: '', url: '', rssUrl: '', countries: ['all'], type: 'local', credibility: 5 });
    const [filter, setFilter] = useState('all');

    useEffect(() => { fetchSources(); }, []);

    const fetchSources = async () => {
        try { const r = await axios.get(API + "/crawl-ops/sources"); if (r.data.status) setSources(r.data.data); } catch(e) {}
        finally { setLoading(false); }
    };

    const saveSrc = async () => {
        if (!form.name) return;
        await axios.post(API + "/crawl-ops/sources", form);
        setShowAdd(false);
        setForm({ name: '', url: '', rssUrl: '', countries: ['all'], type: 'local', credibility: 5 });
        fetchSources();
    };

    const deleteSrc = async (id) => {
        await axios.delete(API + "/crawl-ops/sources/" + id);
        fetchSources();
    };

    const toggleSrc = async (src) => {
        await axios.put(API + "/crawl-ops/sources/" + src._id, { active: !src.active });
        fetchSources();
    };

    const filtered = filter === 'all' ? sources : sources.filter(s => (s.countries || []).includes(filter));
    const typeColor = { wire: '#C29717', local: '#7a9ec2', government: '#4CAF50', osint: '#e88a2a', defense: '#9b59b6' };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={2} pb={2}>
                <Card>
                    <MDBox px={2} pt={1} pb={0.5} display="flex" justifyContent="space-between" alignItems="center">
                        <MDBox display="flex" gap={1} alignItems="center">
                            <MDTypography variant="body2" sx={{ color: "#C29717", fontSize: "11px", textTransform: "uppercase", letterSpacing: "1.5px" }}>
                                Data sources ({filtered.length}/{sources.length})
                            </MDTypography>
                            <select value={filter} onChange={e => setFilter(e.target.value)} style={{background:'#2a2a2a',border:'1px solid rgba(255,255,255,0.12)',borderRadius:'2px',padding:'2px 6px',fontSize:'10px',color:'#ccc',outline:'none'}}>
                                {COUNTRIES.map(c => <option key={c} value={c}>{c}</option>)}
                            </select>
                        </MDBox>
                        <MDTypography component="span" sx={{ color: "#aaa", fontSize: "12px", cursor: "pointer", display: "flex", alignItems: "center", gap: "4px", "&:hover": { color: "#fff" } }} onClick={() => setShowAdd(!showAdd)}>
                            <Icon sx={{ fontSize: "14px !important" }}>add_circle_outline</Icon> Add source
                        </MDTypography>
                    </MDBox>

                    {showAdd && (
                        <MDBox px={2} py={1.5} sx={{ borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
                            <Grid container spacing={1}>
                                <Grid item xs={3}><MDInput type="text" label="Name *" fullWidth value={form.name} onChange={e => setForm({...form, name: e.target.value})} /></Grid>
                                <Grid item xs={3}><MDInput type="text" label="URL" fullWidth value={form.url} onChange={e => setForm({...form, url: e.target.value})} /></Grid>
                                <Grid item xs={3}><MDInput type="text" label="RSS URL" fullWidth value={form.rssUrl} onChange={e => setForm({...form, rssUrl: e.target.value})} /></Grid>
                                <Grid item xs={1.5}>
                                    <MDInput select label="Type" fullWidth value={form.type} onChange={e => setForm({...form, type: e.target.value})} InputLabelProps={{shrink:true}} InputProps={{style:{height:"40px"}}} SelectProps={{style:{height:"40px"}}} sx={{height:"40px"}}>
                                        {TYPES.map(t => <MenuItem key={t} value={t}>{t}</MenuItem>)}
                                    </MDInput>
                                </Grid>
                                <Grid item xs={1.5}><MDInput type="number" label="Credibility" fullWidth value={form.credibility} onChange={e => setForm({...form, credibility: parseInt(e.target.value)||5})} /></Grid>
                                <Grid item xs={12}>
                                    <MDBox display="flex" gap={1}>
                                        <span onClick={saveSrc} style={{padding:'5px 14px',background:'rgba(194,151,23,0.15)',border:'1px solid rgba(194,151,23,0.3)',borderRadius:'2px',color:'#C29717',fontSize:'11px',cursor:'pointer'}}>Save</span>
                                        <span onClick={() => setShowAdd(false)} style={{padding:'5px 14px',border:'1px solid rgba(255,255,255,0.12)',borderRadius:'2px',color:'#888',fontSize:'11px',cursor:'pointer'}}>Cancel</span>
                                    </MDBox>
                                </Grid>
                            </Grid>
                        </MDBox>
                    )}

                    <MDBox px={2} py={1}>
                        {loading ? <MDBox display="flex" justifyContent="center" p={3}><div className="forte-spin" style={{margin:"0 auto"}}></div></MDBox>
                        : filtered.map(src => (
                            <MDBox key={src._id} sx={{ borderBottom: "1px solid rgba(255,255,255,0.04)", py: 1, display: "flex", justifyContent: "space-between", alignItems: "flex-start", opacity: src.active ? 1 : 0.4 }}>
                                <MDBox>
                                    <MDBox display="flex" gap={1} alignItems="center" mb={0.3}>
                                        <span style={{color:'#fff',fontSize:'12px',fontWeight:500}}>{src.name}</span>
                                        <span style={{fontSize:'9px',color:typeColor[src.type]||'#888',background:'rgba(255,255,255,0.04)',borderRadius:'2px',padding:'0 4px'}}>{src.type}</span>
                                        <span style={{fontSize:'9px',color:'#C29717'}}>{src.credibility || 5}/10</span>
                                    </MDBox>
                                    <MDBox display="flex" gap={1} fontSize="10px" color="#888" mb={0.3}>
                                        {src.url && <span>{src.url.replace(/https?:\/\//, '').substring(0, 35)}</span>}
                                        {src.rssUrl && src.rssUrl.startsWith('http') && <span style={{color:'#4CAF50'}}>RSS</span>}
                                        {(!src.rssUrl || !src.rssUrl.startsWith('http')) && <span style={{color:'#e55'}}>No RSS</span>}
                                        {src.lastCrawled && <span>Crawled: {new Date(src.lastCrawled).toLocaleDateString('en-GB',{day:'numeric',month:'short',hour:'2-digit',minute:'2-digit'})}</span>}
                                    </MDBox>
                                    <MDBox display="flex" gap={0.5} flexWrap="wrap">
                                        {(src.countries || []).map(co => <span key={co} style={{fontSize:'9px',color:'#C29717',background:'rgba(194,151,23,0.08)',borderRadius:'2px',padding:'0 4px'}}>{co}</span>)}
                                    </MDBox>
                                </MDBox>
                                <MDBox display="flex" gap={0.8} flexShrink={0} alignItems="center">
                                    <span onClick={() => toggleSrc(src)} style={{width:'12px',height:'12px',borderRadius:'2px',border:'1px solid '+(src.active?'#4CAF50':'rgba(255,255,255,0.15)'),background:src.active?'rgba(76,175,80,0.15)':'transparent',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',fontSize:'8px',color:'#4CAF50'}}>{src.active?'\u2713':''}</span>
                                    <span onClick={() => deleteSrc(src._id)} style={{color:'#888',cursor:'pointer',fontSize:'12px'}}>x</span>
                                </MDBox>
                            </MDBox>
                        ))}
                    </MDBox>
                </Card>
            </MDBox>
        </DashboardLayout>
    );
}
export default DataSources;
